import Vue from "vue";

export default {
	state: {
		materialDetails: {}
	},
	mutations: {
		setMaterialDetailsOnState(state, details) {
			state.materialDetails = details;
		},
		cleanMaterialDetailsOnState(state) {
			state.materialDetails = {};
		}
	},
	actions: {
		getMaterialDetails({ commit }, params) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("material/details", params)
					.then((response) => {
						commit("setMaterialDetailsOnState", response.data.data);
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		getMaterialDetailsForRehomologation({ commit }, dataObj) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("material/materialRehomologation", dataObj)
					.then((response) => {
						this.state.loading = false;
						commit("setProtocolInviteOnState", response.data.data);
						commit("setSpecificRequirementsOnState", response.data.data.specificRequirement);
						commit("setGeneralRequirementsOnState", response.data.data.generalRequirement);
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		},
		getKlassmattMaterialDetails(_, data) {
			this.state.loading = true;
			const encodedWhere = btoa(`ID = ${data.idItem}`);
			const apiUrl = `${data.baseUrl}${encodedWhere}`;

			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.getExternal(apiUrl)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data);
					})
					.catch((error) => {
						this.state.loading = false;
						reject(error);
					});
			});
		}
	},
	getters: {
		materialDetails({ materialDetails }) {
			return materialDetails;
		}
	}
};
